

var localizedShortMonthNames = ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."];

export const formatDate = (date, shortMonth)=> {
    if (date !== null){
        var d = new Date(date);
        if (shortMonth) {
            return getDato(d) + ". " + localizedShortMonthNames[d.getMonth()] + " " + d.getFullYear()
        } else {
            return getDato(d) + "." + getStandardFormatMaaned(d) + "." + d.getFullYear();
        }
    }
    return null;
};

export const extractYear = (date) => {
    if (date !== null) {
        var d = new Date(date);
        return d.getFullYear();
    }
    return null;
};

function getDato(d) {
    var dato = d.getDate().toString();
    if (dato.length === 1) dato = "0" + dato;
    return dato;
}

function getStandardFormatMaaned(d) {
    var maaned = (d.getMonth() + 1).toString();
    if (maaned.length === 1) maaned = "0" + maaned;
    return maaned;
}

export const extractDateAndMonth = (date) => {
    if (date !== null) {
        var d = new Date(date);
        return getDato(d) + "." + getStandardFormatMaaned(d);
    }
    return null;
};




